import React from 'react';
import { Product } from '../../types';
import { formatWindowClosedMonth } from '../../utils/productWindows';

interface VaultProductCardProps {
  product: Product;
  onClick?: (product: Product) => void;
}

const VaultProductCard: React.FC<VaultProductCardProps> = ({ product, onClick }) => {
  return (
    <div 
      className="group relative flex flex-col cursor-pointer"
      onClick={() => onClick && onClick(product)}
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-gray-200 mb-4">
        {/* SOLD OUT Badge */}
        <div className="absolute top-4 left-4 bg-black text-white text-[10px] font-heading font-bold px-2 py-1 z-20 tracking-wider">
           ARCHIVED
        </div>

        {/* Image - Grayscale by default, color on hover */}
        <img
          src={product.image || '/assets/placeholder.svg'}
          alt={product.title}
          onError={(e) => {
            const t = e.currentTarget;
            if (!t.dataset.fallback) { t.dataset.fallback = '1'; t.src = '/assets/placeholder.svg'; }
          }}
          className="absolute inset-0 w-full h-full object-cover object-center filter grayscale transition-all duration-500 group-hover:grayscale-0 opacity-80 group-hover:opacity-100"
        />
        
        {/* Overlay Info */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
           <div className="bg-white/90 px-4 py-2">
              <span className="font-heading font-bold text-xs tracking-widest text-black">VIEW DETAILS</span>
           </div>
        </div>
      </div>

      <div className="text-center space-y-1 opacity-60 group-hover:opacity-100 transition-opacity">
        <h3 className="font-heading font-bold text-lg tracking-wide uppercase">
          {product.title}
        </h3>
        {/* Catalogue caption: "Fragment {n}. Window closed {month year}." */}
        {(product.fragmentNumber || product.windowCloseAt) ? (
          <p className="font-mono text-xs text-gray-500 tracking-widest">
            {product.fragmentNumber ? `Fragment ${product.fragmentNumber}. ` : ''}
            {product.windowCloseAt ? `Window closed ${formatWindowClosedMonth(product.windowCloseAt)}.` : ''}
          </p>
        ) : (
          product.releaseDate && (
            <p className="font-mono text-xs text-gray-500 tracking-widest">
              Released {new Date(product.releaseDate).toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })}.
            </p>
          )
        )}
      </div>
    </div>
  );
};

export default VaultProductCard;
